import PlayerTypeItem from './PlayerTypeItem';

export default PlayerTypeItem;
